import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../hooks/useAppSelector';
import { Header } from './Header';
import { Footer } from './Footer';
import { Spinner } from '../elements/Spinner';

export const AuthLayout = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) navigate('/dashboard');
  }, [isAuthenticated]);

  return (
    <div className="min-h-screen flex flex-col">
      {isAuthenticated ? (
        <div className="h-screen flex items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <>
          <Header />
          <main className="min-h-screen flex flex-col items-center justify-center px-4">
            <div className="text-center mb-12 max-w-2xl">
              <h1 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-neutral-light to-text-muted text-transparent bg-clip-text mb-4">
                Advertise with Fairday
              </h1>
              <p className="text-base sm:text-lg text-text-muted">
                Reach Clients Before They Reach Your Competition
              </p>
            </div>
            <div className="w-full max-w-md glass-card rounded-xl p-6 sm:p-8">
              <Outlet />
            </div>
          </main>
          <Footer />
        </>
      )}
    </div>
  );
};
